<div class="tabs-container">
  <div class="tabs-bar" role="tablist">
    <div
      *ngFor="let tab of tabs"
      class="tab"
      [attr.data-cy]="'tab-' + tab.label.toLowerCase().replace(' ', '-')"
      [class.active]="isActive(tab)"
      [class.highlight]="tab.route === 'upgrade' && !tab.loading"
      [class.loading]="tab.loading"
      role="tab"
      [attr.aria-selected]="isActive(tab)"
      tabindex="0"
      (click)="navigateToTab(tab)"
      (keydown)="handleKeyDown($event)"
    >
      <div class="tab-button-content">
        <i *ngIf="tab.loading" class="fa-solid fa-spinner fa-spin tab-icon"></i>
        <i *ngIf="tab.icon && !tab.loading" [class]="tab.icon" class="tab-icon"></i>
        <span class="tab-label">{{ tab.label }}</span>
      </div>
    </div>
  </div>
</div>
